import ResourceTypeModel           from 'Models/intervention/ResourceTypeModel';
import doc from 'decorators/doc';
import model from 'decorators/model';
import { Timestampable }           from 'helpers/traits';
import { Blamable }                from 'helpers/traits';
import InterventionPrivateApiModel from '../../abstracts/InterventionPrivateApiModel';

@model.cacheDuration()
@model.staticLabel('Type')
@model.urnResource('property_type')
@doc.path('/property_types/{?id}')
export default class PropertyTypeModel extends Blamable(Timestampable(InterventionPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'createdAt[after]': string;
		'createdAt[before]': string;
		'createdAt[strictly_after]': string;
		'createdAt[strictly_before]': string;
		'properties.partitionUrn': string;
		'resourceType.reference': InterventionResourceTypeReference;
		'updatedAt[after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'updatedAt[strictly_before]': string | Date;
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'updatedAt': string;
	}> = {};

	@doc.string declare label: string;
	@doc.model(ResourceTypeModel) declare resourceType: ResourceTypeModel;
}